import type {
  AdminNotificationCategory,
  AdminNotificationSeverity,
  AdminNotificationStatus,
} from "@/services/adminNotificationService";

export type StatusTab = AdminNotificationStatus | "all";

export const SEVERITY_OPTIONS: AdminNotificationSeverity[] = [
  "critical",
  "error",
  "warning",
];

export const CATEGORY_OPTIONS: AdminNotificationCategory[] = [
  "payment",
  "booking",
  "receipt",
  "scheduler",
  "integration",
  "support",
  "device",
];

export function parseStatusTab(value: string | null): StatusTab {
  if (value === "acknowledged" || value === "resolved" || value === "all") {
    return value;
  }
  return "open";
}

export function parseSeverity(
  value: string | null,
): AdminNotificationSeverity | null {
  return SEVERITY_OPTIONS.find((severity) => severity === value) ?? null;
}

export function parseCategory(
  value: string | null,
): AdminNotificationCategory | null {
  return CATEGORY_OPTIONS.find((category) => category === value) ?? null;
}

export function parsePage(value: string | null): number {
  const parsed = parseInt(value || "1", 10);
  return Number.isFinite(parsed) && parsed >= 1 ? parsed : 1;
}

/** Whether a notification with `status` still belongs in the list shown for `tab`. */
export function notificationStaysInTab(
  tab: StatusTab,
  status: AdminNotificationStatus,
): boolean {
  return tab === "all" || status === tab;
}
